<template>
	<section class="posts-grid" v-if="posts && posts.length" :class="'type-' + posts[0].type">
		<div class="posts-line">
			<PostBlock v-for="post in posts" :key="post.id" :data="post" />
		</div>
	</section>
</template>

<script>
import PostBlock from '@/components/elements/PostBlock'

export default {
	name: 'posts-grid',
	props: {
		posts: {
			default: [],
		},
	},
	components: {
		PostBlock,
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.posts-grid {
	overflow: hidden;

	--post-grid-gap: 50px;

	&.type-person {
		--post-grid-gap: 25px;
	}

	.posts-line {
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		grid-gap: var(--post-grid-gap);

		.block {
			grid-column: span 6;
			max-width: 100%;
			max-width: 100%;
			overflow: hidden;

			@include mquery($phone) {
				grid-column: span 12;
			}

			&.type-person {
				grid-column: span 4;

				@include mquery($tablet) {
					grid-column: span 6;
				}

				@include mquery($phone) {
					grid-column: span 12;
				}
			}
		}
	}
}
</style>
